module.exports = __webpack_public_path__ + "assets/img/beishankou_2.c28c247b.png";